import { render, staticRenderFns } from "./ApprovedCompanyDialog.vue?vue&type=template&id=30f3d641&scoped=true"
import script from "./ApprovedCompanyDialog.vue?vue&type=script&lang=js"
export * from "./ApprovedCompanyDialog.vue?vue&type=script&lang=js"
import style0 from "./ApprovedCompanyDialog.vue?vue&type=style&index=0&id=30f3d641&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f3d641",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f3d641')) {
      api.createRecord('30f3d641', component.options)
    } else {
      api.reload('30f3d641', component.options)
    }
    module.hot.accept("./ApprovedCompanyDialog.vue?vue&type=template&id=30f3d641&scoped=true", function () {
      api.rerender('30f3d641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/ApprovedCompanyDialog.vue"
export default component.exports